import React from "react"
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion"
import "../../accordion.css"

import BwDisplay from "../BwDisplay"
import ThrottleBwDisplay from "../ThrottleBwDisplay"

const BwDisplayGroup = ({ isThrottle, month1, month2, month3, nightGigs }) => (
  <Accordion
    allowZeroExpanded={true}
    preExpanded={[0]}
    style={{ maxWidth: "100vw" }}
  >
    {[month1, month2, month3].map((monthData, i) => (
      <AccordionItem key={i}>
        <AccordionItemHeading>
          <AccordionItemButton>
            {monthData["label"]}
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          {isThrottle
            ? <ThrottleBwDisplay nightGigs={nightGigs} monthData={monthData} />
            : <BwDisplay nightGigs={nightGigs} monthData={monthData} />}
        </AccordionItemPanel>
      </AccordionItem>
    ))}
  </Accordion>
)

export default BwDisplayGroup
